module.exports = {
        srcSet: __webpack_public_path__ + "destination_host_gamma-300-92e09a81d49ab26f.digested.png"+" 300w",
        images: [{path: __webpack_public_path__ + "destination_host_gamma-300-92e09a81d49ab26f.digested.png",width: 300,height: 100}],
        src: __webpack_public_path__ + "destination_host_gamma-300-92e09a81d49ab26f.digested.png",
        toString: function(){return __webpack_public_path__ + "destination_host_gamma-300-92e09a81d49ab26f.digested.png"},
        
        width: 300,
        height: 100
      }